<template>
  <resource-loader-controller
    :resource="resource"
    v-slot="{ receive, loading, result }"
  >
    <delayed-executor-controller
      :delay="300"
      :receiver="receive"
      v-slot="{ receive: delayedReceive }"
    >
      <view-component
        v-bind="$attrs"
        :value="internal"
        @input="input"
        @close="close"
        @open="open"
        :filter="filter"
        :result="result"
        :loading="loading"
        :receive="receive"
        :receive-search="delayedReceive"
        :filter-values="filterValues"
      />
    </delayed-executor-controller>
  </resource-loader-controller>
</template>

<script>

import { createResource } from '@md/resources';
import ViewComponent from './Component';
import OpenableMixin from '../OpenableMixin';

export default {
  name: 'filter-autocomplete-select-widget-controller',

  props: [
    'value',
    'filter',
    'values',
    'parameters',
  ],

  mixins: [OpenableMixin],

  components: {
    ViewComponent,
  },

  computed: {
    resource() {
      const { url } = this.filter.props;

      return createResource(
        `${url}{?search,filters,limit,offset}`
      ).transform(response => response.json());
    },

    filterValues() {
      if (
        this.values
        && !Array.isArray(this.values)
        && typeof this.values === 'object'
      ) {
        return this.values;
      }

      if (
        this.parameters
        && this.parameters.values
      ) {
        return this.parameters.values;
      }

      return {};
    },
  },
};

</script>